import {createRef, ReactNode, RefObject} from "react";
import {InputNumber, InputNumberChangeEvent} from "primereact/inputnumber";
import {Button} from "primereact/button";
import {Menu} from "primereact/menu";
import {DropdownChangeEvent, DropdownProps} from "primereact/dropdown";
import {MenuItem, MenuItemCommandEvent} from "primereact/menuitem";
import FunctionHelper from "../helper/FunctionHelper";
import PortalPureComponent from "./PortalPureComponent";

/**
 * The properties for a {@link DropdownNumber} component
 */
interface DropdownNumberProperties extends DropdownProps {
	step?: number;
	min?: number;
	max?: number;
	suffix?: string;
	prefix?: string;
	showButtons?: boolean;
}

/**
 * This component combines an {@link InputNumber} with a {@link Menu} appended to a {@link Button} to make this often
 * used combination reusable
 */
export default class DropdownNumber extends PortalPureComponent<DropdownNumberProperties, any> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let menu: RefObject<Menu> = createRef<Menu>();
		let menuItems: Array<MenuItem> = [];

		for (let item of FunctionHelper.applyValue(this.props.options, [])) {
			menuItems.push({
				label: item.label,
				command: (e: MenuItemCommandEvent) => {
					if (!FunctionHelper.exists(this.props.onChange)) {
						return;
					}

					this.props.onChange!({
						value: item.value,
						originalEvent: e.originalEvent
					} as DropdownChangeEvent);
				}
			});
		}

		return (
			<div className="p-inputgroup dropdown-number">
				<InputNumber value={this.props.value} inputId={this.props.inputId} min={this.props.min}
							 max={this.props.max} useGrouping={false} suffix={this.props.suffix}
							 onChange={(event: InputNumberChangeEvent) => {
								 if (!FunctionHelper.exists(this.props.onChange)) {
									 return;
								 }

								 this.props.onChange!({
									 value: event.value,
									 originalEvent: event.originalEvent
								 } as DropdownChangeEvent);
							 }}
							 prefix={this.props.prefix} showButtons={this.props.showButtons}/>
				<Button icon="icon icon-angle-down" aria-controls={this.props.inputId + "-menu"}
						onClick={(event) => menu.current!.toggle(event)} aria-haspopup={true}/>
				<Menu popup={true} ref={menu} id={this.props.inputId + "-menu"} appendTo={this.props.appendTo}
					  model={menuItems}/>
			</div>
		);
	}
}